/* Coniglio d'Oro — base.js */
(function () {
  'use strict';

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  /* ---------- Mobile drawer (drill-down) ---------- */
  function initMobileMenu() {
    const drawer = $('[data-mobile-drawer]');
    if (!drawer) return;
    const openBtns = $$('[data-mobile-drawer-open]');
    const closeBtns = $$('[data-mobile-drawer-close]');
    const rootList = drawer.querySelector('[data-mobile-level="root"]');
    const subLists = $$('[data-mobile-level="sub"]', drawer);
    const titleEl = drawer.querySelector('[data-mobile-drawer-title]');
    const stack = []; // panel id stack for back navigation

    const showRoot = () => {
      if (rootList) rootList.hidden = false;
      subLists.forEach(s => { s.hidden = true; s.removeAttribute('data-open'); });
      if (titleEl) titleEl.textContent = 'Menu';
      stack.length = 0;
    };

    const drawerPanel = drawer.querySelector('[data-mobile-drawer-panel]');
    const showPanel = (id) => {
      if (rootList) rootList.hidden = true;
      subLists.forEach(s => {
        if (s.id === id) { s.hidden = false; s.setAttribute('data-open', ''); }
        else { s.hidden = true; s.removeAttribute('data-open'); }
      });
      stack.push(id);
      const target = drawer.querySelector('#' + CSS.escape(id));
      if (titleEl && target) titleEl.textContent = target.getAttribute('aria-label') || 'Menu';
      if (drawerPanel) drawerPanel.scrollTop = 0;
    };

    const open = () => { drawer.hidden = false; document.body.style.overflow = 'hidden'; showRoot(); };
    const close = () => { drawer.hidden = true; document.body.style.overflow = ''; showRoot(); };

    openBtns.forEach(b => b.addEventListener('click', open));
    closeBtns.forEach(b => b.addEventListener('click', close));
    drawer.addEventListener('click', e => { if (e.target === drawer) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !drawer.hidden) close(); });

    // Drill into a sub panel
    $$('[data-mobile-open]', drawer).forEach(btn => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-mobile-open');
        if (id) showPanel(id);
      });
    });

    // Back navigation
    $$('[data-mobile-back]', drawer).forEach(btn => {
      btn.addEventListener('click', () => {
        stack.pop(); // remove current
        const prev = stack[stack.length - 1];
        if (prev) {
          // Re-show the previous panel without re-pushing it
          stack.pop();
          showPanel(prev);
        } else {
          showRoot();
        }
      });
    });
  }

  /* ---------- Mega menu (drill-down, hover) ---------- */
  function initMegaMenu() {
    const items = $$('.nav-bar__item[data-has-children="true"]');
    let closeTimer = null;

    const closeAll = () => {
      $$('[data-mega-panel][data-open]').forEach(p => {
        p.removeAttribute('data-open');
        $$('.mega-panel__column--sub[data-open]', p).forEach(s => s.removeAttribute('data-open'));
        $$('[data-active]', p).forEach(r => r.removeAttribute('data-active'));
      });
    };

    items.forEach(item => {
      const panel = item.querySelector('[data-mega-panel]');
      if (!panel) return;

      item.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        // Close any other open panel immediately
        $$('[data-mega-panel][data-open]').forEach(p => {
          if (p !== panel) {
            p.removeAttribute('data-open');
            $$('.mega-panel__column--sub[data-open]', p).forEach(s => s.removeAttribute('data-open'));
            $$('[data-active]', p).forEach(r => r.removeAttribute('data-active'));
          }
        });
        panel.setAttribute('data-open', '');
      });

      item.addEventListener('mouseleave', () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          panel.removeAttribute('data-open');
          $$('.mega-panel__column--sub[data-open]', panel).forEach(s => s.removeAttribute('data-open'));
          $$('[data-active]', panel).forEach(r => r.removeAttribute('data-active'));
        }, 180);
      });

      // Keyboard: open panel when focus enters the nav item, close when it leaves
      const trigger = item.querySelector('a, button');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      item.addEventListener('focusin', () => {
        clearTimeout(closeTimer);
        $$('[data-mega-panel][data-open]').forEach(p => {
          if (p !== panel) {
            p.removeAttribute('data-open');
            $$('.mega-panel__column--sub[data-open]', p).forEach(s => s.removeAttribute('data-open'));
            $$('[data-active]', p).forEach(r => r.removeAttribute('data-active'));
          }
        });
        panel.setAttribute('data-open', '');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('focusout', (e) => {
        if (item.contains(e.relatedTarget)) return;
        panel.removeAttribute('data-open');
        $$('.mega-panel__column--sub[data-open]', panel).forEach(s => s.removeAttribute('data-open'));
        $$('[data-active]', panel).forEach(r => r.removeAttribute('data-active'));
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });

      // Drill-down on hover OR keyboard focus of level-2 rows that have children
      const openDrill = (row) => {
        const targetId = row.getAttribute('data-target');
        if (!targetId) return;
        $$('.mega-panel__column--sub', panel).forEach(s => s.removeAttribute('data-open'));
        $$('.mega-panel__row[data-active]', panel).forEach(r => r.removeAttribute('data-active'));
        const target = panel.querySelector('#' + CSS.escape(targetId));
        if (target) {
          target.removeAttribute('hidden');
          target.setAttribute('data-open', '');
          row.setAttribute('data-active', '');
        }
      };
      $$('.mega-panel__row[data-has-children="true"]', panel).forEach(row => {
        row.addEventListener('mouseenter', () => openDrill(row));
        row.addEventListener('focusin', () => openDrill(row));
      });

      // Back button in sub-panel
      $$('[data-mega-back]', panel).forEach(back => {
        back.addEventListener('click', () => {
          const sub = back.closest('.mega-panel__column--sub');
          if (sub) sub.removeAttribute('data-open');
          $$('[data-active]', panel).forEach(r => r.removeAttribute('data-active'));
        });
      });
    });

    // Close on Escape
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });
  }

  /* ---------- Sticky header on scroll ---------- */
  function initStickyHeader() {
    const header = $('[data-site-header]');
    if (!header) return;
    const onScroll = () => {
      if (window.scrollY > 8) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Search overlay ---------- */
  function initSearchOverlay() {
    const overlay = $('[data-search-overlay]');
    const openBtns = $$('[data-search-open]');
    const closeBtns = $$('[data-search-close]');
    if (!overlay) return;
    const input = overlay.querySelector('input[name="q"]');
    const open = () => {
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      setTimeout(() => input && input.focus(), 50);
    };
    const close = () => {
      overlay.hidden = true;
      document.body.style.overflow = '';
    };
    openBtns.forEach(b => b.addEventListener('click', open));
    closeBtns.forEach(b => b.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !overlay.hidden) close(); });
  }

  /* ---------- Announcement rotator ---------- */
  function initAnnouncementRotator() {
    const root = $('[data-announce]');
    if (!root) return;
    const msgs = $$('[data-announce-msg]', root);
    if (msgs.length <= 1) {
      if (msgs[0]) msgs[0].classList.add('is-active');
      return;
    }
    let i = 0;
    msgs[0].classList.add('is-active');
    setInterval(() => {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4000);
  }

  /* ---------- Wishlist (localStorage) ---------- */
  const wishKey = 'coniglio:wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(wishKey) || '[]'); } catch { return []; }
  }
  function setWishlist(items) { localStorage.setItem(wishKey, JSON.stringify(items)); }
  function updateWishlistCount() {
    const n = getWishlist().length;
    const el = $('[data-wishlist-count]');
    if (el) { el.textContent = n; el.hidden = n === 0; }
  }
  function initWishlist() {
    updateWishlistCount();
    $$('[data-wishlist]').forEach(btn => {
      const handle = btn.dataset.productHandle;
      if (getWishlist().includes(handle)) btn.setAttribute('aria-pressed', 'true');
      btn.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        const items = getWishlist();
        const idx = items.indexOf(handle);
        if (idx > -1) { items.splice(idx, 1); btn.setAttribute('aria-pressed', 'false'); }
        else { items.push(handle); btn.setAttribute('aria-pressed', 'true'); }
        setWishlist(items);
        updateWishlistCount();
      });
    });
  }

  /* ---------- Favorites page ---------- */
  async function initFavoritesPage() {
    const grid = $('[data-favorites-grid]');
    if (!grid) return;
    const empty = $('[data-favorites-empty]');
    const label = $('[data-fav-count-label]');

    async function render() {
      const handles = getWishlist();
      if (label) label.textContent = handles.length === 1 ? '1 sieraad bewaard' : handles.length + ' sieraden bewaard';
      if (!handles.length) {
        grid.hidden = true; grid.innerHTML = '';
        if (empty) empty.hidden = false;
        updateWishlistCount();
        return;
      }
      if (empty) empty.hidden = true;
      grid.hidden = false;
      const products = await Promise.all(handles.map(async h => {
        try {
          const res = await fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } });
          if (!res.ok) return null;
          return await res.json();
        } catch { return null; }
      }));
      grid.innerHTML = '';
      products.forEach((p, i) => {
        if (!p) { // product gone — drop from storage
          const items = getWishlist().filter(x => x !== handles[i]);
          setWishlist(items);
          return;
        }
        let img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && img.indexOf('//') === 0) img = window.location.protocol + img;
        const card = document.createElement('article');
        card.className = 'fav-card';
        card.innerHTML =
          '<a href="' + p.url + '" class="fav-card__media">' + (img ? '<img src="' + img + '&width=600" alt="" loading="lazy">' : '') + '</a>' +
          '<button type="button" class="fav-card__remove" data-fav-remove data-handle="' + p.handle + '" aria-label="Verwijder uit favorieten">&times;</button>' +
          '<a href="' + p.url + '" class="fav-card__title">' + p.title + '</a>' +
          '<p class="fav-card__price">' + fmtEuro(p.price) + '</p>' +
          '<a href="' + p.url + '" class="btn btn--ghost btn--sm">Bekijk</a>';
        grid.appendChild(card);
      });
      updateWishlistCount();
    }

    grid.addEventListener('click', e => {
      const btn = e.target.closest('[data-fav-remove]');
      if (!btn) return;
      const items = getWishlist().filter(x => x !== btn.dataset.handle);
      setWishlist(items);
      render();
    });

    render();
  }

  /* ---------- Cart count refresh ---------- */
  async function updateCartCount() {
    try {
      const res = await fetch(window.shop.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      const el = $('[data-cart-count]');
      if (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      }
    } catch {}
  }
  window.updateCartCount = updateCartCount;

  /* ---------- Card quick-add (ajax) ---------- */
  function initCardAdd() {
    $$('[data-card-add-form]').forEach(form => {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const btn = form.querySelector('[data-card-add]');
        if (!btn) return;
        const orig = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Bezig...';
        try {
          const fd = new FormData(form);
          const res = await fetch(window.shop.routes.cart_add_url + '.js', {
            method: 'POST', body: fd, headers: { 'Accept': 'application/json' }
          });
          if (!res.ok) throw new Error('fail');
          btn.textContent = 'Toegevoegd';
          await updateCartCount();
          setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1400);
        } catch {
          btn.textContent = 'Probeer opnieuw';
          btn.disabled = false;
          setTimeout(() => { btn.textContent = orig; }, 1400);
        }
      });
    });
  }

  /* ---------- Predictive search ---------- */
  function initPredictiveSearch() {
    const overlay = $('[data-search-overlay]');
    if (!overlay) return;
    const form = $('[data-search-form]', overlay);
    const input = $('[data-search-input]', overlay);
    const results = $('[data-search-results]', overlay);
    const quick = $('[data-search-quick]', overlay);
    const clearBtn = $('[data-search-clear]', overlay);
    if (!form || !input || !results) return;

    const emptyHtml = '<p class="search-overlay__empty">Begin met typen om producten en categorie&euml;n te zien.</p>';
    const loadingHtml = '<p class="search-overlay__empty">Zoeken…</p>';
    let timer = null;
    let lastQuery = '';

    function showQuick(show) { if (quick) quick.style.display = show ? '' : 'none'; }

    function reset() {
      results.innerHTML = emptyHtml;
      showQuick(true);
      if (clearBtn) clearBtn.hidden = true;
    }
    reset();

    input.addEventListener('input', () => {
      const q = input.value.trim();
      if (clearBtn) clearBtn.hidden = q.length === 0;
      if (q === lastQuery) return;
      lastQuery = q;
      clearTimeout(timer);
      if (q.length < 2) { reset(); return; }
      results.innerHTML = loadingHtml;
      showQuick(false);
      timer = setTimeout(() => {
        const url = `${window.shop.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,query&resources[limit]=6&section_id=predictive-search`;
        fetch(url)
          .then(r => r.text())
          .then(html => {
            // Shopify wraps section in shopify-section-* div — strip via parse
            const div = document.createElement('div');
            div.innerHTML = html;
            const inner = div.querySelector('.ps') || div;
            results.innerHTML = inner.outerHTML;
          })
          .catch(() => { results.innerHTML = '<p class="search-overlay__empty">Er ging iets mis. Probeer opnieuw.</p>'; });
      }, 220);
    });

    if (clearBtn) clearBtn.addEventListener('click', () => {
      input.value = '';
      lastQuery = '';
      input.focus();
      reset();
    });

    $$('[data-quick-q]', overlay).forEach((btn) => {
      btn.addEventListener('click', () => {
        const q = btn.getAttribute('data-quick-q') || '';
        input.value = q;
        input.dispatchEvent(new Event('input'));
        input.focus();
      });
    });
  }

  /* ---------- Collection filters auto-submit ---------- */
  function initSidebarScrollLock() {
    if (window.innerWidth < 1024) return;
    const sidebar = document.querySelector('.coll__sidebar');
    if (!sidebar) return;
    sidebar.addEventListener('wheel', (e) => {
      e.preventDefault();
      sidebar.scrollTop += e.deltaY;
    }, { passive: false });
  }

  function initCollectionFilters() {
    // client-side tag filtering (geen S&D app nodig)
    const cards = $$('.coll__grid > .card');
    const countEl = $('.coll__count');
    const totalCount = cards.length;

    function applyFilters() {
      const activeTags = $$('[data-filter-tag]:checked').map((cb) => cb.dataset.filterTag.toLowerCase());
      // group tags by their prefix for AND-between-groups, OR-within-group logic
      const groups = {};
      activeTags.forEach((t) => {
        const prefix = t.split('_')[0];
        if (!groups[prefix]) groups[prefix] = [];
        groups[prefix].push(t);
      });

      const priceMin = parseFloat($('[data-filter-price-min]')?.value || '') || null;
      const priceMax = parseFloat($('[data-filter-price-max]')?.value || '') || null;
      const onlyAvail = $('[data-filter-availability="in"]')?.checked || false;

      let shown = 0;
      cards.forEach((card) => {
        const tagsRaw = (card.dataset.tags || '').toLowerCase();
        const tags = tagsRaw.split('||').filter(Boolean);
        const price = parseFloat(card.dataset.price || '0');
        const available = card.dataset.available === 'true';

        // tag check: every group must have at least one match
        let pass = true;
        for (const prefix in groups) {
          const need = groups[prefix];
          const hit = need.some((t) => tags.includes(t));
          if (!hit) { pass = false; break; }
        }
        if (pass && priceMin != null && price < priceMin) pass = false;
        if (pass && priceMax != null && price > priceMax) pass = false;
        if (pass && onlyAvail && !available) pass = false;

        card.style.display = pass ? '' : 'none';
        if (pass) shown++;
      });

      if (countEl) countEl.textContent = shown === totalCount
        ? totalCount + ' sieraden'
        : shown + ' van ' + totalCount + ' sieraden';
    }

    $$('[data-filter-tag], [data-filter-availability]').forEach((cb) => cb.addEventListener('change', applyFilters));
    $$('[data-filter-price-min], [data-filter-price-max]').forEach((inp) => {
      let tm;
      inp.addEventListener('input', () => { clearTimeout(tm); tm = setTimeout(applyFilters, 250); });
    });
    const clear = $('[data-filter-clear]');
    if (clear) clear.addEventListener('click', () => {
      $$('[data-filter-tag]:checked, [data-filter-availability]:checked').forEach((cb) => cb.checked = false);
      const pmin = $('[data-filter-price-min]'); if (pmin) pmin.value = '';
      const pmax = $('[data-filter-price-max]'); if (pmax) pmax.value = '';
      applyFilters();
    });

    const sort = $('[data-sort-select]');
    if (sort) {
      sort.addEventListener('change', () => {
        const url = new URL(window.location);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
    // mobiele drawer
    const drawerOpen = $('[data-filter-drawer-open]');
    const sidebar = $('.coll__sidebar');
    const drawerClose = $('[data-filter-drawer-close]');
    if (drawerOpen && sidebar) {
      drawerOpen.addEventListener('click', () => {
        sidebar.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
      sidebar.addEventListener('click', (e) => {
        if (e.target === sidebar) {
          sidebar.classList.remove('is-open');
          document.body.style.overflow = '';
        }
        drawerClose?.addEventListener('click', () => {
  sidebar.classList.remove('is-open');
  document.body.style.overflow = '';
});
      });
    }
  }

  /* ---------- Testimonials carousel ---------- */
  function initTestimonials() {
    $$('.tmw').forEach(root => {
      const track = root.querySelector('[data-tmw-track]');
      const dots = $$('[data-tmw-dot]', root);
      const cards = $$('[data-tmw-card]', root);
      if (!track || cards.length === 0) return;

      let index = 0;
      const total = cards.length;
      function perView() {
        const w = window.innerWidth;
        if (w < 768) return 1;
        if (w < 1024) return total <= 2 ? 1 : 2;
        return total <= 3 ? 1 : 3;
      }
      function update() {
        const pv = perView();
        root.classList.toggle('tmw--single', pv === 1);
        const maxIndex = Math.max(0, total - pv);
        index = Math.max(0, Math.min(index, maxIndex));
        const cardWidth = cards[0].getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(track).columnGap || '32');
        track.style.transform = `translateX(-${index * (cardWidth + gap)}px)`;
        dots.forEach((d, i) => {
          d.style.display = i > maxIndex ? 'none' : '';
          d.classList.toggle('is-active', i === index);
        });
        const prev = root.querySelector('[data-tmw-prev]');
        const next = root.querySelector('[data-tmw-next]');
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= maxIndex;
      }
      dots.forEach((d, i) => d.addEventListener('click', () => { index = i; clearInterval(auto); update(); }));
      const prevBtn = root.querySelector('[data-tmw-prev]');
      const nextBtn = root.querySelector('[data-tmw-next]');
      if (prevBtn) prevBtn.addEventListener('click', () => { index = Math.max(0, index - 1); clearInterval(auto); update(); });
      if (nextBtn) nextBtn.addEventListener('click', () => { index = index + 1; clearInterval(auto); update(); });

      // touch swipe
      let touchX = null;
      track.addEventListener('touchstart', (e) => { touchX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', (e) => {
        if (touchX == null) return;
        const dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 40) { index = dx < 0 ? index + 1 : Math.max(0, index - 1); clearInterval(auto); update(); }
        touchX = null;
      });

      let auto = setInterval(() => {
        const pv = perView();
        const maxIndex = Math.max(0, total - pv);
        index = index >= maxIndex ? 0 : index + 1;
        update();
      }, 5500);
      root.addEventListener('mouseenter', () => clearInterval(auto));
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Lazy images (IntersectionObserver fallback) ---------- */
  function initLazyImages() {
    if (!('IntersectionObserver' in window)) {
      $$('img[data-src]').forEach(img => { img.src = img.dataset.src; });
      return;
    }
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const img = e.target;
          if (img.dataset.src) img.src = img.dataset.src;
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          io.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    $$('img[data-src]').forEach(img => io.observe(img));
  }

  /* ---------- Money format ---------- */
  function moneyFormat(cents) {
    // NL formatting incl. dot-thousands separator (€ 1.295,00)
    const amount = (cents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (window.shop.money_format || '€{{amount}}')
      .replace(/\{\{\s*amount[^}]*\}\}/i, amount)
      .replace(/<[^>]+>/g, '');
  }
  window.moneyFormat = moneyFormat;

  /* ---------- Newsletter ---------- */
  function initNewsletter() {
    $$('[data-newsletter-form]').forEach(form => {
      form.addEventListener('submit', () => {
        const btn = form.querySelector('button');
        if (btn) btn.textContent = 'Bedankt!';
      });
    });
  }

  /* ---------- Frequently bought together (bulk add) ---------- */
  function fmtEuro(cents) {
    return '€ ' + (cents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function initFbt() {
    const fbt = $('[data-fbt]');
    if (!fbt) return;
    const selfPrice = parseInt(fbt.querySelector('[data-fbt-price]')?.dataset.fbtPrice || '0', 10);
    const options = $$('[data-fbt-option]', fbt);
    const totalEl = fbt.querySelector('[data-fbt-total]');
    const recalc = () => {
      let total = selfPrice;
      options.forEach(o => { if (o.checked) total += parseInt(o.dataset.price || '0', 10); });
      if (totalEl) totalEl.textContent = fmtEuro(total);
    };
    options.forEach(o => o.addEventListener('change', recalc));
    recalc();

    const addBtn = fbt.querySelector('[data-fbt-add]');
    if (!addBtn) return;
    addBtn.addEventListener('click', async () => {
      const items = [{ id: Number(addBtn.dataset.selfId), quantity: 1 }];
      options.forEach(o => { if (o.checked && o.value) items.push({ id: Number(o.value), quantity: 1 }); });
      const orig = addBtn.textContent;
      addBtn.disabled = true; addBtn.textContent = 'Bezig...';
      try {
        const res = await fetch(window.shop.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) throw new Error('fail');
        window.location.href = window.shop.routes.cart_url;
      } catch {
        addBtn.textContent = 'Probeer opnieuw'; addBtn.disabled = false;
        setTimeout(() => { addBtn.textContent = orig; }, 1600);
      }
    });
  }

  /* ---------- Cart cross-sell (add + reload) ---------- */
  function initCrosssell() {
    $$('[data-crosssell-add]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const id = btn.dataset.variantId;
        if (!id) return;
        const orig = btn.textContent;
        btn.disabled = true; btn.textContent = 'Bezig...';
        try {
          const res = await fetch(window.shop.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: Number(id), quantity: 1 })
          });
          if (!res.ok) throw new Error('fail');
          window.location.reload();
        } catch {
          btn.textContent = 'Opnieuw'; btn.disabled = false;
          setTimeout(() => { btn.textContent = orig; }, 1600);
        }
      });
    });
  }

  /* ---------- Cart row qty/remove (full cart page) ---------- */
  async function cartChange(key, quantity) {
    const res = await fetch(window.shop.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    return res.ok;
  }
  function initCartRow() {
    const rows = $$('[data-cart-row]');
    if (!rows.length) return;
    rows.forEach(row => {
      const key = row.dataset.key;
      const qtyInput = row.querySelector('[data-cart-qty]');
      const dec = row.querySelector('[data-cart-decrease]');
      const inc = row.querySelector('[data-cart-increase]');
      const rm = row.querySelector('[data-cart-remove]');

      const setBusy = (b) => { row.style.opacity = b ? '.6' : ''; row.style.pointerEvents = b ? 'none' : ''; };
      const apply = async (q) => {
        if (q < 0) q = 0;
        setBusy(true);
        const ok = await cartChange(key, q);
        if (ok) window.location.reload();
        else setBusy(false);
      };

      if (dec) dec.addEventListener('click', () => {
        const v = Math.max(0, parseInt(qtyInput?.value || '1', 10) - 1);
        apply(v);
      });
      if (inc) inc.addEventListener('click', () => {
        const v = parseInt(qtyInput?.value || '1', 10) + 1;
        apply(v);
      });
      if (qtyInput) qtyInput.addEventListener('change', () => {
        const v = parseInt(qtyInput.value || '0', 10);
        apply(Number.isFinite(v) ? v : 0);
      });
      if (rm) rm.addEventListener('click', (e) => { e.preventDefault(); apply(0); });
    });
  }

  /* ---------- Boot ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    initMobileMenu();
    initMegaMenu();
    initStickyHeader();
    initSearchOverlay();
    initAnnouncementRotator();
    initWishlist();
    initCardAdd();
    initPredictiveSearch();
    initCollectionFilters();
    initSidebarScrollLock();
    initTestimonials();
    initLazyImages();
    initNewsletter();
    initFbt();
    initCrosssell();
    initFavoritesPage();
    initCartRow();
    updateCartCount();
  });
})();
